import classNames from 'classnames';
import * as React from 'react';
import { ReactElement, forwardRef } from 'react';
import './style.css';

type IProps = {
  children: any;
  buttonType?:
    | 'primary'
    | 'ghost-primary'
    | 'secondary'
    | 'destructive'
    | 'confirm';
  size?: 'default' | 'small';
  isDisabled?: boolean;
  isBlock?: boolean;
  className?: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const Button = forwardRef(
  (
    {
      children,
      buttonType = 'primary',
      size = 'default',
      isDisabled,
      isBlock,
      className,
      ...props
    }: IProps,
    ref
  ): ReactElement => {
    const buttonClasses = classNames('button', {
      [`button--${buttonType}`]: buttonType,
      [`button--${size}`]: size,
      'button--disabled': isDisabled,
      'button--block': isBlock,
      [`${className}`]: className,
    });

    return (
      <button
        className={buttonClasses}
        disabled={isDisabled}
        aria-disabled={isDisabled}
        role="button"
        ref={ref}
        {...props}>
        {children}
      </button>
    );
  }
);

export default Button;
